<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Relatório de Alteração de Titularidade</h2>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="mt-3">
          <b-table striped hover show-empty
            :items="transfers"
            :fields="fields"
            primary-key="id"
            sort-icon-left
            empty-filtered-text="Nenhuma alteração de titularidade registrada"
            empty-text="Nenhuma alteração de titularidade registrada"
            responsive>

              <template v-slot:cell(old_owner_data)="data">
                <div v-if="data.item.old_ticket.owner && data.item.old_ticket.owner.name && data.item.old_ticket.owner.document && data.item.old_ticket.owner.phone">
                  <ul>
                    <li>{{ data.item.old_ticket.owner.name }}</li>
                    <li>{{ data.item.old_ticket.owner.document }}</li>
                    <li><b-link target="_blank" :href="mountWhatsAppLink(data.item.old_ticket.owner.phone)">{{ data.item.old_ticket.owner.phone }}</b-link> <icon scale="0.55" name="external-link-alt"></icon></li>
                  </ul>
                </div>
              </template>

              <template v-slot:cell(direction)="">
                <div>
                  <icon scale="0.8" name="arrow-right"></icon>
                </div>
              </template>

              <template v-slot:cell(new_owner_data)="data">
                <div v-if="data.item.new_ticket.owner && data.item.new_ticket.owner.name && data.item.new_ticket.owner.document && data.item.new_ticket.owner.phone">
                  <ul>
                    <li>{{ data.item.new_ticket.owner.name }}</li>
                    <li>{{ data.item.new_ticket.owner.document }}</li>
                    <li><b-link target="_blank" :href="mountWhatsAppLink(data.item.new_ticket.owner.phone)">{{ data.item.new_ticket.owner.phone }}</b-link> <icon scale="0.55" name="external-link-alt"></icon></li>
                  </ul>
                </div>
              </template>

              <template v-slot:cell(created_at_fmted)="data">
                <div>
                  {{ data.item.created_at | date }} <br>
                  <span class="data-extra">{{ data.item.created_at | dateRelative }}</span>
                </div>
              </template>

          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "OrganizerTicketTransfer",
  data () {
    return {
      fields: [
        { key: 'batch.name', label: 'Lote', class: ['align-middle', 'text-center'] },
        { key: 'old_ticket.number', label: 'Nro.', class: ['align-middle', 'text-center'] },
        { key: 'old_owner_data', label: 'Titular antigo', tdClass: ['owner-data-column'], class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'direction', label: '', class: ['text-center', 'align-middle'] },
        { key: 'new_ticket.number', label: 'Nro.', class: ['align-middle', 'text-center'] },
        { key: 'new_owner_data', label: 'Titular novo', tdClass: ['owner-data-column'], class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'created_at_fmted', label: 'Data', formatter: this.$options.filters.date, class: ['align-middle', 'text-nowrap', 'text-center'] },
        { key: 'user_agent', label: 'Dispositivo', formatter: this.$options.filters.userAgent, tdClass: ['data-extra'], class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'location', label: 'Local', tdClass: ['data-extra'], class: ['text-center', 'align-middle', 'text-nowrap'] },
      ],
      transfers: [],
    }
  },
  async mounted () {
    this.organizer = this.$route.params.organizer
    await this.getTicketTransfers()
  },
  methods: {
    mountWhatsAppLink (phone) {
      if (!phone) return
      let numbers = String(phone).replace(/\D/g, '')
      return `https://api.whatsapp.com/send?phone=55${numbers}`
    },
    async getTicketTransfers () {
      let url = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/ticket-transfers`
      try {
        let resp = await this.$http.get(url)
        this.transfers = resp.body.transfers
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss">
.owner-data-column {
  div {
    font-size: 11px;
    line-height: 13px;
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        margin-bottom: 3px;
      }
    }
  }
}
.data-extra {
  font-size: 13px;
}
</style>
